import { render, staticRenderFns } from "./fccPublicacoes.vue?vue&type=template&id=628b91ee"
import script from "./fccPublicacoes.vue?vue&type=script&lang=js"
export * from "./fccPublicacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports